const NonOtcPlpVeticalCardShimmer = () => {
  return (
    <div className="mx-auto min-h-[244px] relative h-60 w-full bg-white rounded-lg px-1.5 py-2 shadow-practicalTop justify-center animate-pulse">
      <div className="h-24 m-auto  rounded-lg flex justify-center items-center relative">
        <div className="w-24 h-24 bg-gray-300 rounded" />
      </div>

      <div className="mt-2 text-xs flex flex-col justify-between h-[calc(100%-112px)]">
        <div className="flex flex-col gap-1">
          <div className="h-3 bg-gray-300 rounded w-full mb-1"></div>
          <div className="h-3 bg-gray-300 rounded w-3/4"></div>
        </div>
        <div className="flex flex-col">
          <div className="text-xs mt-auto">
            <div className="h-4 w-16 bg-gray-300 rounded-full"></div>
          </div>
          <div className="mt-2 text-xs w-full flex gap-1 overflow-auto">
            <div className="h-4 w-10 bg-gray-300 rounded-full"></div>
            <div className="h-4 w-10 bg-gray-300 rounded-full"></div>
            <div className="h-4 w-10 bg-gray-300 rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NonOtcPlpVeticalCardShimmer;
